import { useEffect } from 'react';

const ChatWidget = () => {
  useEffect(() => {
    // Create script element
    const script = document.createElement('script');
    script.src = '//code.tidio.co/go9nvxyiulak2ct21ykifyvrh5zbdl1e.js';
    script.async = true;
    
    // Append script to document
    document.body.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      document.body.removeChild(script);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return null; // This component doesn't render anything
};

export default ChatWidget; 